import { useState } from 'react';
import { Alert, Button } from 'antd';
import LoginLayout from '../../components/layout/login/Login.layout';
import { getOidcManager } from '../../service/auth/oidc';

const LoginPage = () => {
  const [error, setError] = useState(false);
  const [signedOut] = useState(() => {
    const flag = sessionStorage.getItem('signedOut') === '1';
    sessionStorage.removeItem('signedOut');
    return flag;
  });
  const redirect = () => {
    setError(false);
    sessionStorage.setItem('oidc:returnTo', localStorage.getItem('lastVisitedPath') || '/');
    localStorage.removeItem('lastVisitedPath');
    void getOidcManager().signinRedirect().catch(() => setError(true));
  };

  return (
    <LoginLayout>
      <p className="mb-6 text-gray-600">
        Continue with your SeeWard identity to access the platform securely.
      </p>
      {signedOut && (
        <Alert
          className="mb-4"
          type="success"
          showIcon
          message="You have been signed out."
        />
      )}
      {error && (
        <p className="mb-4 text-red-600">
          Unable to reach the identity provider. Please try again.
        </p>
      )}
      <Button
        type="primary"
        size="large"
        block
        onClick={redirect}
      >
        Sign in
      </Button>
    </LoginLayout>
  );
};
export default LoginPage;
